var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFasttag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3939 52.5552H10.1613C5.09968 52.5552 1 48.4555 1 43.3939V10.1613C1 5.09968 5.09968 1 10.1613 1H43.3939C48.4555 1 52.5552 5.09968 52.5552 10.1613V43.3939C52.5552 48.444 48.444 52.5552 43.3939 52.5552Z",
    fill: "#F2FFFA",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.825 23.5922L33.7266 24.5166L35.053 27.5278L37.1514 26.6035L35.825 23.5922Z",
    fill: "#05D484"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9776 20.4382L36.8789 21.3623L38.205 24.3739L40.3037 23.4498L38.9776 20.4382Z",
    fill: "#05D484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8675 40.4601H16.7305V16.543H30.8675V40.4601ZM17.877 39.3136H29.7209V17.6895H17.877V39.3136Z",
    fill: "#09081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4416 17.6894H16.158C15.5159 17.6894 15 17.162 15 16.5314V14.158C15 13.5159 15.5159 13 16.158 13H17.0982V14.1466H16.158L16.1466 16.5314L31.4416 16.5429L31.4531 14.158L18.4167 14.1466V13H31.4416C32.0837 13 32.5996 13.5159 32.5996 14.158V16.5199C32.5996 17.162 32.0837 17.6894 31.4416 17.6894Z",
    fill: "#09081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7826 30.1183H19.8255C19.1719 30.1183 18.6445 29.5909 18.6445 28.9374V20.3841C18.6445 19.7305 19.1719 19.2031 19.8255 19.2031H27.7826C28.4361 19.2031 28.9635 19.7305 28.9635 20.3841V28.9374C28.9521 29.5909 28.4246 30.1183 27.7826 30.1183ZM19.8255 20.3497L19.7911 28.9374L27.7826 28.9718C27.8055 28.9718 27.817 28.9603 27.817 28.9374V20.3841L19.8255 20.3497Z",
    fill: "#09081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7826 38.5909H19.8255C19.1719 38.5909 18.6445 38.0635 18.6445 37.41V32.7894C18.6445 32.1358 19.1719 31.6084 19.8255 31.6084H27.7826C28.4361 31.6084 28.9635 32.1358 28.9635 32.7894V37.41C28.9521 38.0635 28.4246 38.5909 27.7826 38.5909ZM19.8255 32.755L19.7911 37.41L27.7826 37.4444C27.8055 37.4444 27.817 37.4329 27.817 37.41V32.7894L19.8255 32.755Z",
    fill: "#09081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9188 40.4595H29.7109V29.0054C29.7109 27.8474 30.6511 26.9072 31.8091 26.9072C32.9672 26.9072 33.9073 27.8474 33.9073 29.0054V35.9994H32.7608V29.0054C32.7608 28.478 32.3365 28.0538 31.8091 28.0538C31.2817 28.0538 30.8575 28.478 30.8575 29.0054V39.313H32.7722V37.6734H33.9188V40.4595Z",
    fill: "#09081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7565 30.13L32.9425 29.3274L40.8995 21.1983C41.0715 21.0263 41.1747 20.7855 41.1747 20.5448C41.1747 20.2925 41.0715 20.0403 40.8766 19.8568C40.6932 19.6734 40.4639 19.5817 40.2116 19.5817C39.9594 19.5817 39.7186 19.6848 39.5351 19.8683L31.6812 27.8942L30.8672 27.0916L38.7211 19.0657C39.1224 18.6644 39.6498 18.4351 40.2116 18.4351C40.7849 18.4122 41.2894 18.6529 41.6907 19.0428C42.092 19.4326 42.3327 19.9829 42.3327 20.5448C42.3327 21.0836 42.1149 21.6225 41.7251 22.0009L33.7565 30.13Z",
    fill: "#09081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0755 30.1179H21.5352V28.6159C21.5352 27.3661 22.5556 26.3457 23.8053 26.3457C25.0551 26.3457 26.0755 27.3661 26.0755 28.6159V30.1179ZM22.6817 28.9713H24.929V28.6159C24.929 27.9967 24.4245 27.4923 23.8053 27.4923C23.1862 27.4923 22.6817 27.9967 22.6817 28.6159V28.9713Z",
    fill: "#09081A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasttag);
export default __webpack_public_path__ + "static/media/fasttag.6c9fed71.svg";
export { ForwardRef as ReactComponent };